module.exports = __webpack_public_path__ + "img/try-video-button.543f8755.png";